module.exports = __webpack_public_path__ + "static/media/021.d5fd6aa6.jpg";